import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import classnames from 'classnames'
import { WinkingChip } from 'labguard-cdk'
import styles from './AlarmWinkingChip.scss'

const AlarmWinkingChip = ({ winkingAlarm, colors, nbAlarms, textClassName, ...domProps }) => (
  <WinkingChip
    wink={get(winkingAlarm, 'toBeAcknowledged')}
    color={colors[0] || 'light'}
    badge={colors[1]}
    {...domProps}
  >
    <text className={classnames(styles.count, textClassName)}>{nbAlarms}</text>
  </WinkingChip>
)

AlarmWinkingChip.propTypes = {
  winkingAlarm: PropTypes.shape({
    toBeAcknowledged: PropTypes.bool,
  }),
  colors: PropTypes.arrayOf(PropTypes.string),
  nbAlarms: PropTypes.number,
  textClassName: PropTypes.string,
}

export default AlarmWinkingChip
